export default {
  full_menu: 'Meniu complet',
  free: 'GRATUIT',
};
